/**
 * It removes trailing zeroes from a number or string
 * @param {number | string} value - number | string
 */
export const removeTrailingZero = (value: number | string) => {
	value = String(value);

	const [beforeDot, afterDot] = value.split('.');

	// Return `value` if there is nothing after the dot
	if (!afterDot) return value;

	// Return `value` if `afterDot` is an integer
	if (Number.isNaN(Number(afterDot))) return value;

	// Trim trailing zeroes off of `numberAfterDot` while it's divisible by 10
	let numberAfterDot = Number(afterDot);
	while (numberAfterDot > 1 && numberAfterDot % 10 === 0) numberAfterDot = numberAfterDot / 10;

	// Concatenate `beforeDot` and `numberAfterDot` without a decimal point if `numberAfterDot` is equal to 0
	return numberAfterDot ? `${beforeDot}.${numberAfterDot}` : beforeDot;
};